// extracted by mini-css-extract-plugin
export default {"tooltip_pro_container":"PremiumFeatureTooltip_tooltip_pro_container__m1tkp","header":"PremiumFeatureTooltip_header__QtFbU","text":"PremiumFeatureTooltip_text__LcDax"};